/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * UpSmith Dev API
 * OpenAPI spec version: 1.0.0
 */

export type CompetitionEntryType =
  (typeof CompetitionEntryType)[keyof typeof CompetitionEntryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompetitionEntryType = {
  team: "team",
  user: "user",
} as const;
